import { render, staticRenderFns } from "./DynamicInformation.vue?vue&type=template&id=b9ba4938&scoped=true&"
import script from "./DynamicInformation.vue?vue&type=script&lang=js&"
export * from "./DynamicInformation.vue?vue&type=script&lang=js&"
import style0 from "./DynamicInformation.vue?vue&type=style&index=0&id=b9ba4938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ba4938",
  null
  
)

export default component.exports